module.exports = __webpack_public_path__ + "img/tron (77).5ff22cf6.jpg";